var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-button"},[_c('button',{class:{ 'btn-primary': _vm.data.Text !== 'Cancel' },attrs:{"type":"button"},on:{"click":function($event){return _vm.onButtonClick(_vm.data)}}},[_c('Localize',{attrs:{"text":_vm.data.Text}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }